export * from './lib/shared-mat-dialog-delete.module';
export { MatDialogDeleteComponent } from './lib/mat-dialog-delete/mat-dialog-delete.component'
